/* @flow */

export const socialSharingPlugin = 'social_sharing';
